import React from 'react';
import { Chip } from '@mui/material';
import classNames from 'classnames';
import { splitTextByChannelMention } from '../utils/channelMention';
import { mdToHTML } from '../utils/mdToHTML';

type Props = {
  text: string;
  isOwnerStyle?: boolean;
  isPinned?: boolean;
};

const LINK_TRUNCATE_LENGTH = 42;

export const TextWithChannelMention = ({
  text,
  isOwnerStyle = false,
  isPinned = false,
}: Props) => {
  const parts = splitTextByChannelMention(text);
  const linkClassName = isOwnerStyle ? 'text-white' : undefined;
  const mentionStyle = {
    color: 'var(--primary-P-80, #5F1ECC)',
    fontFamily: 'Visuelt, sans-serif',
    fontSize: '16px',
    fontStyle: 'normal',
    fontWeight: 400,
    lineHeight: '24px',
  };

  const onContentClickCapture = (ev: React.MouseEvent<HTMLSpanElement>) => {
    const target = ev.target as HTMLElement;
    if (target.closest('a')) {
      ev.stopPropagation();
    }
  };

  return (
    <>
      {parts.map((part, index) =>
        part.isChannelMention ? (
          <span key={index} style={mentionStyle}>
            {part.text}
          </span>
        ) : (
          <span
            key={index}
            onClickCapture={onContentClickCapture}
            style={{
              color: isOwnerStyle
                ? 'var(--bw-white-W-100, #FFF)'
                : 'var(--bw-black-B-100, #000)',
              fontFamily: 'Visuelt, sans-serif',
              fontSize: '16px',
              fontStyle: 'normal',
              fontWeight: 400,
              lineHeight: '24px',
              whiteSpace: 'pre-wrap',
            }}
            dangerouslySetInnerHTML={{
              __html: mdToHTML(part.text, {
                truncate: LINK_TRUNCATE_LENGTH,
                linkClassName,
              }),
            }}
          />
        ),
      )}
    </>
  );
};
